/* @flow */

export default class NotificationSetting {
  id: number;
  statusKey: string;
  isFixed: bool;
  isChecked: bool;
}
